import MealPlanManagement from "./pages/MealPlanManagement";
import MealManagement from "./pages/MealManagement";
import DailyOrdersReports from "./pages/DailyOrdersReports";
import UserManagement from "./pages/UserManagement";
import { faCalendarDays, faFileLines, faUtensils, faUserPen, faChartPie, faGear } from '@fortawesome/free-solid-svg-icons';
import Stats from "./pages/Stats";
import OrderSettingsPage from "./pages/OrderSettingsPage";

export const routes = [
    { path: '/orders-management', name: 'Αναφορές Παραγγελιών',layout:'/admin', component: <DailyOrdersReports/>, icon: faFileLines },
    { path: '/menu-management', name: 'Διαχείριση Μενού',layout:'/admin', component: <MealPlanManagement/>,  icon: faCalendarDays },
    { path: '/meal-management', name: 'Διαχείριση Γευμάτων',layout:'/admin', component: <MealManagement/>,icon: faUtensils },
    { path: '/user-management', name: 'Διαχείριση Χρηστών',layout:'/admin', component: <UserManagement/>,icon:faUserPen },
    { path: '/stats', name: 'Στατιστικά Γευμάτων',layout:'/admin', component: <Stats/>,icon:faChartPie },
    { path: '/settings', name: 'Ρυθμίσεις',layout:'/admin', component: <OrderSettingsPage/>,icon:faGear },
  ];
